export enum PendingAreaOrderStatusType {
    Pending = 1,
    Approved = 2,
    PartiallyApproved = 3,
}